import styled from 'styled-components';

import { BaseEditField } from 'legacyComponents/styled/lib';

import { media } from 'styles/utils';

import Heading from 'components/Heading';

import Icon from 'components/Icon';

export const NameInput = styled(BaseEditField)`
  width: 100%;
  font-size: ${props => props.theme.font.size.xlarge};
  position: relative;
  display: inline-block;
  > input {
    font-weight: ${props => props.theme.font.weight.xbold};
    width: 100%;
    ::placeholder {
      font-weight: ${props => props.theme.font.weight.xbold};
    }
  }
`;

export const IconStyled = styled(Icon)`
  margin-left: ${props => props.theme.spacing.default};
  margin-top: -8px;
`;

export const By = styled.small`
  font-size: ${props => props.theme.spacing.medium};
  margin: 0 0 ${props => props.theme.spacing.large};
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  > a {
    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ProjectNameStyled = styled.div`
  word-break: break-word;
  /** Media queries */
  ${media.large`
    width: 55%;
  `}
`;

export const CommitsWrapper = styled.div`
  margin-left: 2.5rem;
`;

export const HeadingStyled = styled(Heading)`
  margin: 0;
  font-size: ${props => props.theme.font.size.xlarge};
  line-height: 1;
`;

const circleSize = '2rem';
export const CircleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: ${circleSize};
  max-width: ${circleSize};
  min-height: ${circleSize};
  max-height: ${circleSize};
  border: 1px solid ${props => props.theme.color.wfBlack};
  border-radius: ${circleSize};
  margin-right: ${props => props.theme.spacing.small};
`;
